export const textProperties = [
    'content',
    'horizontalAlignment',
    'verticalAlignment',
    'font',
    'fontSize',
    'maxRows',
    'padding',
    'textOverflow',
    'textColor',
    'uppercase',
    'underline',
    'strikethrough',
    'characterSpacing',
    'lineHeight',
    'textShadows',
    'width',
    'height',
    '__fontFamilyId'
];
export const characterProperties = [
    '__fontFamilyId',
    'characterSpacing',
    'font',
    'fontSize',
    'lineHeight',
    'strikethrough',
    'textColor',
    'textShadows',
    'underline',
    'uppercase'
];
export const textAndCharacterProperties = [...textProperties, ...characterProperties];
export const serializableStateProperties = [
    'border',
    'fill',
    'filters',
    'id',
    'mirrorX',
    'mirrorY',
    'name',
    'opacity',
    'originX',
    'originY',
    'radius',
    'ratio',
    'rotationX',
    'rotationY',
    'rotationZ',
    'scaleX',
    'scaleY',
    'shadows',
    'textColor',
    'x',
    'y'
];
